import { render, staticRenderFns } from "./CustomReportForm.vue?vue&type=template&id=2a9faf5b&scoped=true&"
import script from "./CustomReportForm.vue?vue&type=script&lang=js&"
export * from "./CustomReportForm.vue?vue&type=script&lang=js&"
import style0 from "./CustomReportForm.vue?vue&type=style&index=0&id=2a9faf5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9faf5b",
  null
  
)

export default component.exports